module.exports = __webpack_public_path__ + "static/img/310.31782f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210427/310.jpg
// module id = z4tz
// module chunks = 0